import { fetchPost, fetchGet , fetchPut , fetchDelete} from '@/utils/request'


export function getNewsModelList (query) {  //楼讯模板列表
    return fetchGet('/gateway/v1/news-templates/list', query)
}
export function getNewsModelDetail(id) { //楼讯模板详情
    return fetchGet('/gateway/v1/news-templates/'+id)
}
export function deleteNewsModel (id) { //删除楼讯模板
    return fetchDelete('/gateway/v1/news-templates/'+id)
}
export function editNewsModel (id,query) { //编辑楼讯模板
    return fetchPut('/gateway/v1/news-templates/'+id,query)
}
export function newsModelAdd (query) { //模板添加
    return fetchPost('/gateway/v1/news-templates',query)
}
export function getNewsModelScan (id) {  //楼讯模板预览
    return fetchGet('/gateway/v1/news-templates/preview/'+id)
}
export function newsCreate (query) { //异步生成资讯
    return fetchPost('/gateway/v1/news-templates/asyn-create',query)
}
export function newsCreateByHouse (query) { //按楼盘异步生成资讯
    return fetchPost('/gateway/v1/news-templates/asyn-create-by-house',query,{
        'Content-Type': 'multipart/form-data'
    })
}
export function NewsCreatedlList (query) {  //资讯生成列表
    return fetchGet('/gateway/v1/news-templates/news-create-list', query)
}
export function exportNewsList (query) {  //导出资讯生成列表
    return fetchGet('/gateway/v1/news-templates/news-create-export', query)
}

export function modelRecordList (query) {  //文章生成记录
    return fetchGet('/gateway/v1/news-tpl-record', query)
}
export function modelRecordDetail (query) {  //文章生成记录详情列表
    return fetchGet('/gateway/v1/news-tpl-record/detail-list', query)
}

export function getCntListByPage (query) {  //资讯内容项列表（分页查询）
    return fetchGet('/gateway/v1/news-content-templates/paginator', query)
}
export function getCntList (query) {  //资讯内容项列表
    return fetchGet('/gateway/v1/news-content-templates/list', query)
}
export function getCntDetail (id) {  //资讯内容项详情
    return fetchGet('/gateway/v1/news-content-templates/'+id)
}
export function editNewsCnt(id,query) { //修改楼讯内容项
    return fetchPut('/gateway/v1/news-content-templates/'+id,query)
}
export function deleteNewsCnt (id) { //删除楼讯内容项
    return fetchDelete('/gateway/v1/news-content-templates/'+id)
}
export function NewsCntAdd (query) { //添加楼讯内容项
    return fetchPost('/gateway/v1/news-content-templates',query)
}
export function getLabelVal (query) {  //获取动态取值标签
    return fetchGet('/gateway/v1/news-dynamic-label',query)
}
export function getHouseRule () {  //楼盘调用规则列表
    return fetchGet('/gateway/v1/news-house-rules/')
}
export function insertHouse (query) { //正文插入楼盘
    return fetchPost('/gateway/v1/news-rule-content',query)
}
export function getInsertHouse (id) {  //查询正文插入楼盘
    return fetchGet('/gateway/v1/news-rule-content/'+ id)
}
export function editInsertHouse (id,query) {  //修改正文插入楼盘
    return fetchPut('/gateway/v1/news-rule-content/'+ id,query)
}
export function changeStatus (id) {  //修改资讯模板审核状态
    return fetchPut('/gateway/v1/news-templates/approve-status/'+ id)
}

export function getPriceData (query) {  //获取站点折线图数据
    return fetchGet('/gateway/v1/house-price-chart/chart-data',query)
}
export function creatPriceData (query) {  //创建价格折线图
    return fetchPost('/gateway/v1/house-price-chart',query)
}

export function comparePriceData (query) {  //判断需要生成的数据
    return fetchGet('/gateway/v1/house-price-chart/check',query)
}
